import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CdkTrapFocus } from '@angular/cdk/a11y';

@Component({
  selector: 'tnq-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CdkTrapFocus],
})
export class ModalComponent {
  readonly hasBackdrop = input<boolean>(false);
  readonly ariaLabel = input<string>('');
  readonly back = output<void>();
}
